<h1 mat-dialog-title>{{'Select displayed columns' | translate}}</h1>
<div mat-dialog-content>
  <hr>
    <mat-checkbox (change)="toggleSelectAll($event)"
      [checked]="areAllSelected">
      {{'Select all' | translate}}
    </mat-checkbox>
    <hr>
      @if (showBoundMatSelectionList) {
        <mat-selection-list id="list"
          (cdkDropListDropped)="drop($event)" cdkDropList>
          @for (column of columns; track column) {
            <mat-list-option (click)="toggle(column); $event.preventDefault();"
              [selected]="column.selected"
              cdkDrag>
              <div class="mat-typography">
                @if (column.isCustomAttribute) {
                  <i [matTooltip]="'Custom attribute' | translate">{{column.header | async}}</i>
                } @else {
                  {{column.header | async}}
                }
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      }
    </div>
    <div mat-dialog-actions>
      <button (click)="save()" id="save" mat-button type="button">{{'Save' | translate}}</button>
      <button mat-dialog-close id="cancel" mat-button type="button">{{'Cancel' | translate}}</button>
      <button mat-button id="reset" (click)="resetToDefault()" type="button">{{'Reset to default' | translate}}</button>
    </div>
